module.exports = __webpack_public_path__ + "static/media/auchan9.0f653b42.jpg";